module.exports = __webpack_public_path__ + "static/media/tubteam3.3c387e39.jpeg";